
import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import jsonApi from '@/api/json';
import { message as $message } from 'ant-design-vue';
import storeArg from '@/untils/storeArg';

export default defineComponent({
  name: 'CreateShop',
  data() {
    return {
      shopMainGoodsList: [],
      regionsAll: [],
      region: '',
      params: {
        shopMainGoods: null,
        shopName: '',
        address: '',
        provinceId: '',
        cityId: '',
        regionId: '',
      },
      center: { lng: 116.487925, lat: 40.002525 },
      zoom: 18,
      visible: false,
      title: '',
      content: '',
      checked: false,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    this.getJson();
  },
  components: {
  },
  methods: {
    supplementShop() {
      console.log(this.params);
      console.log(this.region);
      if (!this.params.shopName) {
        this.error('请输入商城名称');
        return;
      }
      // if (!this.params.shopMainGoods) {
      //   this.error('请选择你的主营品类');
      //   return;
      // }
      // if (this.region.length < 3) {
      //   this.error('请选择地址');
      //   return;
      // }
      // if (!this.params.address) {
      //   this.error('请输入详细地址');
      //   return;
      // }
      if (!this.checked) {
        this.error('请勾选商城协议');
        return;
      }
      const param = {
        shopName: this.params.shopName,
        // shopMainGoods: this.params.shopMainGoods,
        // provinceId: this.region[0],
        // cityId: this.region[1],
        // regionId: this.region[2],
        // address: this.params.address,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      console.log(param);
      commonApi.createShop(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          const parent = this.$parent as unknown as {[x: string]: Function};
          const store = (this as any).$store;
          store.state.isShowGoBack = true;
          store.state.isNew = 1;
          parent.nextStep(3);
        } else {
          this.error(message);
          console.log(message);
        }
      });
    },
    getJson() {
      jsonApi.shopMainGoods().then((data: Record<string, object>) => {
        Object.keys(data).forEach((key) => {
          this.shopMainGoodsList.push(data[key] as never);
        });
      });
      jsonApi.regionsAll().then((data: Record<string, object>) => {
        this.dealRegions(data);
        console.log(this.regionsAll);
      });
    },
    dealRegions(data: TObject, type?: string) {
      const arr = Object.values(data);
      if (!type) {
        this.regionsAll = arr as never;
      }
      arr.forEach((item: TObject) => {
        const tem = item;
        if (item.children && JSON.stringify(item.children) !== '{}') {
          tem.children = Object.values(item.children);
          this.dealRegions(item.children, 'child');
        } else {
          tem.children = '';
        }
      });
    },
    openShopModal() {
      this.title = '商城协议';
      this.content = storeArg;
      this.visible = true;
    },
  },
});
